import BaseService from '../BaseService'

export default class KantonService extends BaseService {
  constructor() {
    super('kanton')
  }

}
